import React, { useState } from 'react';
import { Avatar, IconButton, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import * as Sentry from "@sentry/react";
import { redirectToLogin } from '../../auth';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&:focus': {
    backgroundColor: 'transparent',
    outline: 'none',
  },
  '&:active': {
    backgroundColor: 'transparent',
    outline: 'none',
    boxShadow: 'none',
  },
}));

const AvatarNameSpan = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(1),
  marginRight: theme.spacing(1),
  fontSize: '16px',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
}));

const UserAvatar = ({ name }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleClose();
    Sentry.captureMessage("Manual logout - redirecting to login", {
      level: "info",
    });
    redirectToLogin();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'avatar-menu' : undefined;

  // Always pull from the first and last name if available
  const getInitials = (name) => {
    const words = name.trim().split(' ');

    if (words.length === 1) {
      // If only one name is provided, repeat the first letter twice
      return `${words[0][0]}${words[0][1] || words[0][0]}`.toUpperCase();
    }

    // Otherwise, use the first letter of the first and last name
    const firstNameInitial = words[0][0];
    const lastNameInitial = words[words.length - 1][0]; // Takes from the last word (last name)

    return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
  };

  return (
    <div>
      <StyledIconButton
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
        disableRipple={true}
        disableFocusRipple={true}
        size="large"
      >
        <StyledAvatar>{getInitials(name)}</StyledAvatar>
        <AvatarNameSpan>{name}</AvatarNameSpan>
        <ArrowDropDownIcon />
      </StyledIconButton>
      <Menu
        id={id}
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleLogout}>Sign out</MenuItem>
      </Menu>
    </div>
  );
};

export default UserAvatar;
